import { type FormEvent } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { METODO_PAGAMENTO_LABEL } from '../constants'
import type { MetodoPagamento, PagamentoEditorState, ParticipanteEvento } from '../types'

interface PaymentModalProps {
  editor: PagamentoEditorState | undefined
  participante: ParticipanteEvento | null
  onClose: () => void
  onChange: (state: PagamentoEditorState) => void
  onSubmit: (event: FormEvent<HTMLFormElement>) => void
}

export function PaymentModal({
  editor,
  participante,
  onClose,
  onChange,
  onSubmit,
}: PaymentModalProps) {
  if (!editor || !participante) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/60 p-4 sm:items-center"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-2xl bg-background p-6 shadow-2xl ring-1 ring-border"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="mb-4 space-y-1">
          <h3 className="text-xl font-semibold">Registrar pagamento</h3>
          <p className="text-sm text-muted-foreground">
            Confirme o recebimento para <strong>{participante.nome}</strong>
          </p>
        </div>
        <form
          onSubmit={(event) => {
            onSubmit(event)
          }}
          className="space-y-4"
        >
          <div className="space-y-2">
            <Label htmlFor="valor-pagamento-modal">Valor recebido (R$)</Label>
            <Input
              id="valor-pagamento-modal"
              type="number"
              min="0"
              step="0.01"
              value={editor.valor}
              onChange={(event) =>
                onChange({
                  ...editor,
                  valor: event.target.value,
                })
              }
            />
          </div>

          <div className="space-y-2">
            <Label>Método de pagamento</Label>
            <Select
              value={editor.metodo}
              onValueChange={(value) =>
                onChange({
                  ...editor,
                  metodo: value as MetodoPagamento,
                })
              }
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {Object.entries(METODO_PAGAMENTO_LABEL).map(([metodo, label]) => (
                  <SelectItem key={metodo} value={metodo}>
                    {label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row sm:justify-end">
            <Button type="button" variant="outline" className="sm:w-auto" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit" className="sm:w-auto">
              Confirmar pagamento
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}
